import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { Store } from '@ngrx/store';
import { GridApi, IRowNode } from 'ag-grid-enterprise';

import { SharedTranslocoModule } from '@schaeffler/transloco';

import { selectCalculation } from '@cdba/core/store';
import { Calculation } from '@cdba/shared/models';

@Component({
  selector: 'cdba-load-bom-button',
  templateUrl: './load-bom-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    MatButtonModule,
    MatTooltipModule,
    SharedTranslocoModule,
  ],
})
export class LoadBomButtonComponent {
  private readonly store = inject(Store);

  @Input() gridApi: GridApi;

  selections: Calculation[] = [];

  loadBom(): void {
    const nodeSelected = this.selectedNodes()[0];

    this.store.dispatch(
      selectCalculation({
        nodeId: nodeSelected.id,
        calculation: nodeSelected.data,
      })
    );
  }

  buttonDisabled(): boolean {
    const nodesSelected = this.selectedNodes();

    if (nodesSelected.length !== 1) {
      return true;
    }

    return nodesSelected[0]?.data?.costType === 'RFQ';
  }

  tooltipDisabled(): boolean {
    const nodesSelected = this.selectedNodes();

    if (nodesSelected.length !== 1) {
      return true;
    }

    return nodesSelected[0]?.data?.costType !== 'RFQ';
  }

  private readonly selectedNodes = (): IRowNode[] =>
    this.gridApi ? this.gridApi.getSelectedNodes() || [] : [];
}
